<form lin-layout-form class="scheduled-form" [formGroup]="form" (ngSubmit)="submitForm()">
  <lin-progress-bar [isShown]="isLoading$ | async"></lin-progress-bar>
  <lin-layout-form-sections-wrapper>
    <lin-layout-form-section layout="double">
      <!--  type  -->
      <lin-form-label>{{ 'FIELDS.type' | translate }}:</lin-form-label>
      <mat-form-field [class.g-disabled]="true">
        <input matInput disabled formControlName="type" autocomplete="off" />
        <mat-error><lin-form-field-error [control]="form.get('type')" controlName="type"></lin-form-field-error></mat-error>
      </mat-form-field>

      <!--  name  -->
      <lin-form-label required>{{ 'FIELDS.title' | translate }}:</lin-form-label>
      <mat-form-field>
        <input matInput formControlName="title" autocomplete="off" />
        <mat-error><lin-form-field-error [control]="form.get('title')" controlName="title"></lin-form-field-error></mat-error>
      </mat-form-field>

      <label>{{ 'SETTINGS.TIMEZONE' | translate }}:</label>
      <mat-form-field>
        <lin-form-timezone-select [timezones]="timezones" formControlName="timezone"></lin-form-timezone-select>
        <mat-error>
          <lin-form-field-error [control]="form.get('timezone')" controlName="timezone"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <!--  frequencies  -->
      <lin-form-label required>{{ 'FIELDS.frequency' | translate }}</lin-form-label>
      <mat-form-field>
        <mat-select formControlName="frequency">
          <mat-option *ngFor="let frequency of frequencyItems" [value]="frequency">{{ 'FIELDS.' + frequency | translate }}</mat-option>
        </mat-select>
        <mat-error><lin-form-field-error [control]="form.get('frequency')" controlName="frequency"></lin-form-field-error></mat-error>
      </mat-form-field>

      <!--  period  -->
      <ng-container *ngIf="frequencyValue && periodItems?.length">
        <lin-form-label required>{{ 'FIELDS.period' | translate }}</lin-form-label>
        <mat-form-field>
          <mat-select formControlName="period">
            <mat-option *ngFor="let period of periodItems" [value]="period">{{ period }}</mat-option>
          </mat-select>
          <mat-error><lin-form-field-error [control]="form.get('period')" controlName="period"></lin-form-field-error></mat-error>
        </mat-form-field>
      </ng-container>

      <!--  day  -->
      <ng-container *ngIf="frequencyValue && dayItems?.length">
        <lin-form-label required>{{ 'FIELDS.day' | translate }}</lin-form-label>
        <mat-form-field>
          <mat-select formControlName="day">
            <mat-option *ngFor="let day of dayItems" [value]="day.id">{{ day.label }}</mat-option>
          </mat-select>
          <mat-error><lin-form-field-error [control]="form.get('day')" controlName="day"></lin-form-field-error></mat-error>
        </mat-form-field>
      </ng-container>

      <!--  time  -->
      <ng-container *ngIf="frequencyValue">
        <lin-form-label required>{{ 'FIELDS.time' | translate }}</lin-form-label>
        <mat-form-field>
          <mat-select formControlName="time">
            <mat-option *ngFor="let time of frequencyData?.time" [value]="time">{{ time }}</mat-option>
          </mat-select>
          <mat-error><lin-form-field-error [control]="form.get('time')" controlName="time"></lin-form-field-error></mat-error>
        </mat-form-field>
      </ng-container>

      <!-- scheduled report status -->
      <lin-form-label>{{ 'FIELDS.STATUS' | translate }}</lin-form-label>
      <mat-checkbox aria-label="{{ 'FIELDS.DISABLED' | translate }}" formControlName="status">
        {{ 'FIELDS.DISABLED' | translate }}
      </mat-checkbox>
    </lin-layout-form-section>

    <lin-layout-form-section layout="double">
      <!--  format  -->
      <lin-form-label required>{{ 'FIELDS.format' | translate }}</lin-form-label>
      <mat-form-field>
        <mat-select formControlName="format">
          <mat-option value="csv">{{ 'FIELDS.csv' | translate }}</mat-option>
          <mat-option *ngIf="!isEventLog" value="pdf">{{ 'FIELDS.pdf' | translate }}</mat-option>
          <mat-option *ngIf="data.hasXlsx" value="xlsx">{{ 'FIELDS.xlsx' | translate }}</mat-option>
        </mat-select>
        <mat-error><lin-form-field-error [control]="form.get('format')" controlName="format"></lin-form-field-error></mat-error>
      </mat-form-field>
      <!--  recipients type  -->
      <lin-form-label required>{{ 'FIELDS.RECIPIENTS' | translate }}</lin-form-label>
      <mat-form-field>
        <mat-select formControlName="recipientsType">
          <mat-option [value]="RecipientType.Role">{{ 'FIELDS.ROLE' | translate }}</mat-option>
          <mat-option [value]="RecipientType.UserList">{{ 'FIELDS.USER' | translate }}</mat-option>
          <mat-option *ngIf="!user.isAdmin()" [value]="RecipientType.UserGroupList">{{ 'FIELDS.USER_GROUP' | translate }}</mat-option>
        </mat-select>
        <mat-error
          ><lin-form-field-error [control]="form.get('recipientsType')" controlName="recipientsType"></lin-form-field-error
        ></mat-error>
      </mat-form-field>

      <!--  recipients value  -->
      <lin-form-label [required]="!otherEmails.length"
        >{{ RecipientFormControlLabels[valueOf('recipientsType')] | translate }}</lin-form-label
      >
      <lin-form-field>
        <lin-form-checkbox-search-list formControlName="recipientsValue" [items]="recipientItems" [matchWith]="matchWith">
          <span *ng="let item; let search = search" innerHTML="{{ item.label | highlight: search }}"></span>
        </lin-form-checkbox-search-list>
      </lin-form-field>

      <!--  otherEmail  -->
      <lin-form-label>{{ 'FIELDS.otherEmails' | translate }}:</lin-form-label>
      <mat-form-field class="email-chip-list">
        <mat-chip-grid #chipList>
          <mat-chip-row *ngFor="let email of otherEmails" (removed)="remove(email)">
            {{ email }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        </mat-chip-grid>
        <input
          [matChipInputFor]="chipList"
          [formControl]="otherEmail"
          [placeholder]="'PLACEHOLDERS.ADD_EMAIL' | translate"
          (matChipInputTokenEnd)="add($event)"
        />
        <mat-hint>{{ 'FIELDS.otherEmailTooltip' | translate }}</mat-hint>
      </mat-form-field>
    </lin-layout-form-section>
  </lin-layout-form-sections-wrapper>

  <lin-layout-form-toolbar>
    <lin-form-submit-button [isLoading]="isSubmitting" [isDisabled]="!!otherEmail.value.length && !otherEmailIsValid"
      >{{ 'BUTTONS.SAVE' | translate }}</lin-form-submit-button
    >
  </lin-layout-form-toolbar>
</form>
